<template>
  <nav class="navbar">
    <div @click="$router.push('/')" class="logo-container">
      <img :src="require('@/assets/nav.png')" alt="Logo" />
    </div>

    <!-- Menu mobile -->
    <v-app-bar-nav-icon
      class="d-flex d-sm-none ml-auto"
      color="white"
      @click="drawer = !drawer"
    ></v-app-bar-nav-icon>

    <!-- Menu desktop -->
    <ul
      class="d-none d-sm-flex ml-sm-8 nav-list"
      style="margin-left: 5rem !important"
    >
      <li class="item-lista" @click="$router.push('/sobrenos')">Sobre nós</li>
      <v-divider
        class="divider"
        length="50"
        vertical
        :thickness="2"
        color="black"
      ></v-divider>
      <v-menu
        transition="slide-y-transition"
        location="bottom"
        origin="top"
        offset="0"
      >
        <template v-slot:activator="{ props }">
          <li class="item-lista" v-bind="props">Estrutura e Serviços</li>
        </template>
        <v-list elevation="10" class="group_item rounded-b-lg" rounded="0">
          <v-list-item
            class="item"
            @click="$router.push('/servicos/arapiraca')"
          >
            <v-list-item-title>Arapiraca</v-list-item-title>
          </v-list-item>
          <v-divider :thickness="2" color="black"></v-divider>
          <v-list-item
            class="item"
            @click="$router.push('/servicos/saomiguel')"
          >
            <v-list-item-title>São Miguel dos Campos</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-divider
        class="divider"
        length="50"
        vertical
        :thickness="2"
        color="black"
      ></v-divider>
      <v-menu
        transition="slide-y-transition"
        location="bottom"
        origin="top"
        offset="0"
      >
        <template v-slot:activator="{ props }">
          <li class="item-lista" v-bind="props">Nossos planos</li>
        </template>
        <v-list elevation="10" class="group_item rounded-b-lg" rounded="0">
          <v-list-item class="item" @click="$router.push('/planos/arapiraca')">
            <v-list-item-title>Arapiraca</v-list-item-title>
          </v-list-item>
          <v-divider :thickness="2" color="black"></v-divider>
          <v-list-item class="item" @click="$router.push('/planos/saomiguel')">
            <v-list-item-title>São Miguel dos Campos</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-divider
        class="divider"
        length="50"
        vertical
        :thickness="2"
        color="black"
      ></v-divider>
      <a
        class="item-lista"
        href="https://velorios.gpdf.com.br/cemiterioprevida"
        target="_blank"
        style="all: unset; cursor: pointer; height: 100%; display: flex"
      >
        <li class="item-lista" style="height: auto">Nota de Falecimento</li>
      </a>
      <v-menu
        transition="slide-y-transition"
        location="bottom"
        origin="top"
        offset="0"
      >
        <template v-slot:activator="{ props }">
          <v-btn variant="text" elevation="0" v-bind="props">
            <v-icon size="30" color="white">mdi-menu</v-icon>
          </v-btn>
        </template>
        <v-list elevation="10" class="group_item rounded-b-lg" rounded="0">
          <v-list-item
            class="item"
            tag="a"
            href="https://pagamento.cemiterioprevida.com.br/"
            target="_blank"
            rel="noopener"
          >
            <v-list-item-title>Área do cliente</v-list-item-title>
          </v-list-item>
          <v-divider
            :thickness="0"
            color="black"
            class="mx-4 mx-sm-8"
          ></v-divider>
          <v-list-item class="item" tag="a" href="#footer-page" rel="noopener">
            <v-list-item-title>Entre em contato</v-list-item-title>
          </v-list-item>
          <v-divider
            :thickness="0"
            color="black"
            class="mx-4 mx-sm-8"
          ></v-divider>
          <v-list-item
            class="item"
            tag="a"
            href="https://api.whatsapp.com/send/?phone=558000091700&text&type=phone_number&app_absent=0"
            target="_blank"
            rel="noopener"
          >
            <v-list-item-title>Atendimento 24h</v-list-item-title>
          </v-list-item>
          <v-divider
            :thickness="0"
            color="black"
            class="mx-4 mx-sm-8"
          ></v-divider>
          <v-list-item
            class="item"
            target="_blank"
            rel="noopener"
            @click="dialog = true;"
          >
            <v-list-item-title>Localize seu jazigo</v-list-item-title>
          </v-list-item>
          <v-divider
            :thickness="0"
            color="black"
            class="mx-4 mx-sm-8"
          ></v-divider>
          <v-list-item
            class="item"
            tag="a"
            href="https://pagamento.cemiterioprevida.com.br/"
            target="_blank"
            rel="noopener"
          >
            <v-list-item-title>2ª Via do boleto</v-list-item-title>
          </v-list-item>
          <!-- <v-divider
            :thickness="0"
            color="black"
            class="mx-4 mx-sm-8"
          ></v-divider>
          <v-list-item
            class="item"
            tag="a"
            href="https://jazigo.cemiterioprevida.com.br/"
            target="_blank"
            rel="noopener"
          >
            <v-list-item-title>Localização</v-list-item-title>
          </v-list-item> -->
        </v-list>
      </v-menu>

      <!-- <v-divider
        class="divider"
        length="50"
        vertical
        :thickness="4"
        color="black"
      ></v-divider>
      <li class="item-lista">
        Portal do Titular
        <v-icon class="ml-2" size="30">mdi-account-circle</v-icon>
      </li> -->
    </ul>

    <!-- Navigation drawer para mobile -->
    <v-navigation-drawer
      v-model="drawer"
      location="right"
      temporary
      class="bg-primary"
    >
      <v-list>
        <v-list-item class="d-flex justify-end">
          <v-btn variant="text" color="white" @click="drawer = false">
            <v-icon size="30">mdi-close</v-icon>
          </v-btn>
        </v-list-item>
        <v-divider class="mb-2"></v-divider>
        <v-list-item
          href="https://pagamento.cemiterioprevida.com.br/"
          target="_blank"
        >
          <v-list-item-title class="text-white"
            >Área do cliente</v-list-item-title
          >
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item
          @click="dialog = true"
        >
          <v-list-item-title class="text-white"
            >Localize seu jazigo</v-list-item-title
          >
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item @click="$router.push('/sobrenos')">
          <v-list-item-title class="text-white">Sobre nós</v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item
          href="https://velorios.gpdf.com.br/cemiterioprevida"
          target="_blank"
        >
          <v-list-item-title class="text-white"
            >Nota de Falecimento</v-list-item-title
          >
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item @click="$router.push('/servicos/arapiraca')">
          <v-list-item-title class="text-white"
            >Estrutura - Arapiraca</v-list-item-title
          >
        </v-list-item>
        <v-list-item @click="$router.push('/servicos/saomiguel')">
          <v-list-item-title class="text-white"
            >Estrutura - São Miguel</v-list-item-title
          >
        </v-list-item>
        <v-divider></v-divider>

        <v-list-item @click="$router.push('/planos/arapiraca')">
          <v-list-item-title class="text-white"
            >Nossos Planos - Arapiraca</v-list-item-title
          >
        </v-list-item>
        <v-list-item @click="$router.push('/planos/saomiguel')">
          <v-list-item-title class="text-white"
            >Nossos Planos - São Miguel</v-list-item-title
          >
        </v-list-item>
        <v-divider></v-divider>

        <!-- <v-list-item target="_blank">
          <v-list-item-title class="text-white">Portal do Titular</v-list-item-title>
        </v-list-item> -->
      </v-list>
    </v-navigation-drawer>
    <v-dialog v-model="dialog" max-width="600" class="pa-4">
      <v-card class="dialog-card">
        <v-card-title class="text-center pa-4">
          <span class="dialog-title">Escolha uma unidade</span>
        </v-card-title>
        <v-card-text class="pa-4 pa-sm-6 pt-0">
          <div class="cemiterios-grid">
            <v-btn
              class="cemiterio-btn"
              elevation="2"
              rounded="lg"
              @click="handleUnitClick('arapiraca')"
              style="text-transform: none !important"
            >
              <div class="cemiterio-content">
                <h3>Cemitério Previda</h3>
                <h4>Arapiraca</h4>
              </div>
            </v-btn>

            <v-btn
              class="cemiterio-btn"
              elevation="2"
              rounded="lg"
              @click="handleUnitClick('saomiguel')"
              style="text-transform: none !important"
            >
              <div class="cemiterio-content">
                <h3>Cemitério Previda</h3>
                <h4>São Miguel dos Campos</h4>
              </div>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      drawer: false,
      dialog: false,
      jazigoLinks: {
        arapiraca: "https://jazigo.cemiterioprevida.com.br/arapiraca",
        saomiguel: "https://jazigo.cemiterioprevida.com.br/saomiguel",
      },
    };
  },
  methods: {
    handleUnitClick(unit) {
      window.open(this.jazigoLinks[unit], "_blank");
      this.dialog = false;
      this.currentAction = null;
    },
  },
};
</script>

<style scoped>
.navbar {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  background: linear-gradient(to right, var(--bg-primary), #00598f);
  min-height: 8vh;
  padding-left: 4vw;
}

@media (max-width: 600px) {
  .navbar {
    padding-left: 0;
  }

  .logo-container {
    position: relative !important;
    width: 25vh !important;
    height: 70px !important;
  }

  .logo-container img {
    width: 25vh !important;
    height: 70px !important;
  }
}

.divider {
  height: 50% !important;
  margin-top: 1rem !important;
}

.nav-list {
  display: flex;
  align-items: center;
  background: linear-gradient(to right, var(--bg-primary), #00598f);
  min-height: 8vh;
  padding-left: 8vw;
}

.item-lista {
  color: white;
  font-weight: 500;
  transition: opacity 0.3s ease;
  cursor: pointer;
}

.item-lista:hover {
  opacity: 0.8;
}

.nav-list a {
  text-decoration: none;
  color: white;
  font-weight: 500;
  transition: opacity 0.3s ease;
}

.nav-list a:hover {
  opacity: 0.8;
}

ul {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 90vw;
  height: 100%;
  padding: 0 3rem;
}

.item-lista {
  list-style: none;
  font-size: 1rem;
  display: flex;
  align-items: center;
  padding: 1rem;
  font-weight: 600;
  white-space: nowrap;
}

li:hover {
  color: var(--white);
}

.logo-container {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 30vh;
  height: 8rem;
  z-index: 10;
  overflow: hidden;
  cursor: pointer;
}

.group_item {
  background-color: var(--bg-primary) !important;
  border-bottom: 100px !important;
}

.item {
  color: var(--white-soft);
  font-family: "Poppins", sans-serif;
  text-align: center;
  padding: 0.2rem 0;
  cursor: pointer;
}

.item:hover {
  color: var(--white);
}

.logo-container img {
  width: 30vh;
  object-fit: cover;
}

/* Estilização do Dialog */
:deep(.dialog-card) {
  border-radius: 16px;
  overflow: hidden;
}

.dialog-title {
  font-size: 1.6rem;
  font-weight: 600;
  color: var(--bg-primary);
}

@media (min-width: 600px) {
  .dialog-title {
    font-size: 1.8rem;
  }
}

.cemiterios-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-top: 16px;
}

@media (min-width: 600px) {
  .cemiterios-grid {
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-top: 20px;
  }
}

.cemiterio-btn {
  height: auto !important;
  padding: 16px !important;
  background: white !important;
  border: 2px solid var(--bg-primary) !important;
  transition: all 0.3s ease;
}

@media (min-width: 600px) {
  .cemiterio-btn {
    padding: 24px !important;
  }
}

.cemiterio-content h3 {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--bg-primary);
  margin-bottom: 4px;
}

.cemiterio-content h4 {
  font-size: 1rem;
  font-weight: 500;
  color: var(--bg-secondary);
  margin-bottom: 8px;
}

@media (min-width: 600px) {
  .cemiterio-content h3 {
    font-size: 1.4rem;
  }
  
  .cemiterio-content h4 {
    font-size: 1.2rem;
  }
}

.cemiterio-btn:hover {
  background: linear-gradient(to right, var(--bg-primary), var(--bg-secondary)) !important;
  transform: translateY(-2px);
}

.cemiterio-btn:hover .cemiterio-content h3,
.cemiterio-btn:hover .cemiterio-content h4,
.cemiterio-btn:hover .cemiterio-content p {
  color: white !important;
}
</style>
